import { createSelector } from 'reselect'

/** A Redux selector to retrieve Owner Name
 * @param state - The Redux state
 * @param {String} - The URL Params to fetch
 */

const getOwnerData = (state: any) => state.owner

export const selectCalendlyAccountName = createSelector(
  getOwnerData,
  (data) => data && data.ownerData ? data.ownerData.calendlyAccountName : null
)

/** A Redux selector to retrieve owner data loading
 * @param state - The Redux state
 * @param {Boolean} - Fetching Owner Data in progress
 */

export const selectOwnerDataIsLoading = createSelector(
  getOwnerData,
  (data) => data && data.status ? data.status.isLoading : null
)
